import PropTypes from "prop-types"
import {
  FeatureContextInput,
  useFeatureContextQuery
} from "../../api/generated"
import { featureContextPropType } from "../propTypes"

type Props =
  | {
      context: FeatureContextInput | null
      cohortId?: number
    }
  | {
      context?: FeatureContextInput | null
      cohortId: number
    }

type ComponentProps = {
  context: FeatureContextInput
  cohortName: string
  communityEnabled: boolean
}

const withFeatureContext =
  <T extends any>(
    Component: React.ComponentType<T & ComponentProps>
  ): React.ComponentType<T & ComponentProps> =>
  (props: Props & T) => {
    const cohortId = props.cohortId || props.context?.cohort_id

    const featureContextQuery = useFeatureContextQuery({
      variables: { cohortId: cohortId! },
      skip: !cohortId
    })

    const cohort = featureContextQuery.data?.cohort

    if (!cohort) return null

    const context = props.context || {
      cohort_id: cohort.id,
      resource_id: cohort.resource?.id
    }

    // community can be completely disabled if discussion is disabled
    // in either the cohort or resource, this will be replaced by a
    // discussion CFP, but handling in this way for initial release
    const discussionEnabled = !!(
      cohort.discussion_enabled && cohort.resource?.discussion_enabled
    )

    return (
      <Component
        {...props}
        context={context}
        cohortName={cohort.name}
        communityEnabled={discussionEnabled}
      />
    )
  }

withFeatureContext._propTypes = {
  context: featureContextPropType,
  // for getting full feature context if not provided via props
  cohortId: PropTypes.number
}

export default withFeatureContext
